import Signin from "../components/Signin"
export default function SigninPage(){
    return(
        <Signin />
    );
};